import { render, staticRenderFns } from "./bankStatement.vue?vue&type=template&id=29dfd5de"
import script from "./bankStatement.vue?vue&type=script&lang=js"
export * from "./bankStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports